<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('floatAmount') }}</div>
      <div>
        <router-link
          class="btn-blue"
          :to="{ path: '/cinema-manager/edit-float-amount', query: { id: this.float_id }}"
        >{{ $t('edit') }}</router-link>
        <router-link class="btn-blue" to="float-amount">{{ $t('floatAmount') }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div v-for="(item,itemIndex) in floatAmountObject" v-if="itemIndex == 0" class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('shift', 1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ item.shift_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('date') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ item.created_at | dateparse }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('role', 1) }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >POS {{ $t('operation') }} {{ item.hs_hardware_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('currency', 1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ item.curr_code }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('amount') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ item.float_amount_given }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('status', 1) }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ item.float_is_active === 'Y' ? $t('active'): '' }}</div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1 " class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
                <span>{{ item.created_by }}</span>
              </div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1 " class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ item.created_at | dateparse }}</span>
                <!-- <span class="mr-3">06/04/2019</span>
                <span>12:05 AM</span>-->
              </div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1 " class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ item.updated_by }}</span>
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
              </div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1 " class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ item.updated_at | dateparse }}</span>
                <!-- <span class="mr-3">06/04/2019</span>
                <span>12:05 AM</span>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 <script>
import CinemasService from "@/services/CinemasService";
export default {
  data() {
    return {
      login_user_role_id: null,
      floatAmountObject: [],
      float_id: null,
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    if (id) {
      this.getCinemaFloatAmountDetails(id);
    } else {
      this.$router.go(-1);
    }
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {},
  methods: {
    getCinemaFloatAmountDetails: function (float_id) {
      CinemasService.GetFloatAmountById({ float_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.floatAmountObject = data.Records;
            this.float_id = data.Records[0].float_id;
            // this.getShiftsList(data.Records[0].operator_user_id);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
  },
};
</script>
 


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/FloatAmountComponents/viewFloatAmount.vue